export const CART_KEY = 'cart';
export const COOKIE_CONSENT_KEY = 'cookieConsentSettings';
